import { I18n } from '@calendly/i18n'
import { useSelector } from 'react-redux'

import { useEventType } from 'features/event_type_provider'
import { isAdminOrOwnerOrGroupAdminSelector } from 'selectors/current_user'

import { Summary } from './summary'
import { AccordionPanel } from '../../../../components/accordion'
import { Hosts } from '../../hosts'

export const HostsPanel = ({ isLocked, isReadOnly, ...props }) => {
  const isAdminOrOwnerOrGroupAdmin = useSelector(isAdminOrOwnerOrGroupAdminSelector)

  const { isSolo, isGroup, isUser, isMETParent } = useEventType()

  if ((isUser && !isAdminOrOwnerOrGroupAdmin) || isMETParent) return null

  const hostsTitle = (isGroup || (isSolo && isUser))
    ? I18n.t('publisher.event_types.host')
    : I18n.t('publisher.event_types.hosts')

  return (
    <AccordionPanel
      titleId="host-label"
      title={hostsTitle}
      subheader={<Summary />}
      {...props}
    >
      <Hosts isLocked={isLocked} isReadOnly={isReadOnly} />
    </AccordionPanel>
  )
}
